import { IDict } from "./types";

export const pt: IDict = {
  Jobs: "Trabalhos",
  "No Jobs": "Sem Trabalhos",
  Billing: "Faturamento",
  Credits: "Créditos",
  "Pay Per Use": "Pague Por Uso",
  "Feature Voting": "Votação de Recursos",
  "Free Karaoke Left": "Karaokê Grátis Restante",
  "Upgrade Now to Create More": "Faça Upgrade Agora para Criar Mais",
  "Storage is Full": "Armazenamento cheio",
  "Youka is running out of storage space":
    "Youka está ficando sem espaço de armazenamento",
  "Please free up at least 1 GB before creating new karaoke":
    "Por favor, libere pelo menos 1 GB antes de criar um novo karaokê",
  "Click the button to check again": "Clique no botão para verificar novamente",
  "No Internet Connection": "Sem conexão com a Internet",
  "Youka cannot connect to the internet":
    "Youka não pode se conectar à internet",
  "Please make sure you have internet connection":
    "Por favor, certifique-se de ter conexão com a internet",
  "Update is ready": "A atualização está pronta",
  "Click the button to update": "Clique no botão para atualizar",
  "Library Folder": "Pasta da Biblioteca",
  "Export Folder": "Pasta de Exportação",
  "Sync Model": "Modelo de Sincronização",
  "Max Video Quality": "Qualidade Máxima de Vídeo",
  "Speed / Compression Preset": "Predefinição de Velocidade / Compressão",
  Change: "Alterar",
  "dialogs.upgrade.upgrade_to_pro":
    "O recurso que você procura faz parte do plano Pro, atualize agora para desbloquear esse recurso.",
  "dialogs.upgrade.upgrade_to_standard":
    "O recurso que você procura faz parte do plano Standard, atualize agora para desbloquear esse recurso.",
  heads_up: "Atenção!",
  "dialogs.edit_lyrics.not_supported":
    "O idioma que você escolheu atualmente não é compatível com sincronização automática de letras. No entanto, você pode salvar seu progresso e utilizar o Line Level Editor para sincronizar as letras manualmente.",
  "dialogs.create.title": "Criar novo karaokê",
  "dialogs.create.description":
    "Por favor, preencha o formulário abaixo para criar um novo karaokê, você pode usar arquivo de áudio ou vídeo, letras são opcionais.",
  "dialogs.edit_lyrics.description":
    "Após salvar, o processo de sincronização será iniciado, você pode acompanhar o andamento na aba Jobs",
  "dialogs.upgrade.see_plans": "Ver Planos",
  "dialogs.upgrade.unlock": "Desbloquear",
  "comps.sync_editor.attach_previous": "Anexar à palavra anterior",
  "comps.sync_editor.attach_next": "Anexar à próxima palavra",
  "comps.plans.title":
    "Escolha o plano que melhor se adequa às suas necessidades. Você sempre pode fazer upgrade ou downgrade",
  "Font Size": "Tamanho da Fonte",
  Spacing: "Espaçamento",
  Outline: "Contorno",
  "Margin Bottom": "Margem Inferior",
  "Max Chars per Line": "Máx. Caracteres por Linha",
  Bold: "Negrito",
  Italic: "Itálico",
  Shadow: "Sombra",
  month: "mês",
  songs: "músicas",
  Title: "Título",
  "Save and Sync": "Salvar e Sincronizar",
  Lyrics: "Letras",
  Update: "Atualizar",
  Playlist: "Playlist",
  Canceling: "Cancelando",
  Play: "Tocar",
  "Lyrics Language": "Idioma das Letras",
  "Background Image": "Imagem de Fundo",
  "Basic Version": "Versão Básica",
  "Standard Version": "Versão Padrão",
  "Pro Version": "Versão Pro",
  "Trial Version": "Versão de Teste",
  "No Active Plan": "Sem Plano Ativo",
  "Days Left in Trial": "Dias Restantes no Teste",
  Paste: "Colar",
  "Sync Lyrics": "Sincronizar Letras",
  Show: "Exibir",
  Settings: "Configurações",
  Retry: "Tentar Novamente",
  "Create Karaoke": "Criar Karaokê",
  Canceled: "Cancelado",
  Reset: "Redefinir",
  "Edit Video": "Editar Vídeo",
  Download: "Baixar",
  "Edit Metadata": "Editar Metadados",
  "Subtitle Designer": "Designer de Legendas",
  Export: "Exportar",
  year: "ano",
  Basic: "Básico",
  Standard: "Padrão",
  Pro: "Pro",
  Accept: "Aceitar",
  "Add new word": "Adicionar nova palavra",
  "Add to queue": "Adicionar à fila",
  "An unknown error occurred": "Um erro desconhecido ocorreu",
  Annually: "Anualmente",
  "Are you sure you want to delete this karaoke song?":
    "Tem certeza de que deseja deletar esta música de karaokê?",
  "Artist Name": "Nome do Artista",
  "Audio or Video File": "Arquivo de Áudio ou Vídeo",
  Audio: "Áudio",
  "Auto Karaoke Generator": "Gerador de Karaokê Automático",
  "Auto Lyrics Sync": "Sincronização Automática de Letras",
  "Cancel Plan": "Cancelar Plano",
  Cancel: "Cancelar",
  Close: "Fechar",
  "Create Karaoke from song": "Criar Karaokê a partir da Música",
  "Create Karaoke from local files":
    "Criar Karaokê a partir de arquivos locais",
  "Create new karaoke": "Criar novo karaokê",
  Create: "Criar",
  "Current Plan": "Plano Atual",
  "Dark Mode": "Modo Escuro",
  Decline: "Recusar",
  "Delete word": "Deletar palavra",
  Delete: "Deletar",
  "Edit Lyrics": "Editar Letras",
  Edit: "Editar",
  "Export to mp3/mp4": "Exportar para mp3/mp4",
  "Go Back to EULA": "Voltar para o EULA",
  "Go back": "Voltar",
  "Go forward": "Avançar",
  Home: "Início",
  "I accept the terms and commit to avoiding unlicensed use of copyrighted content":
    "Eu aceito os termos e me comprometo a evitar o uso não licenciado de conteúdo protegido por direitos autorais",
  Instruments: "Instrumentos",
  Key: "Tonalidade",
  Library: "Biblioteca",
  "Light Mode": "Modo Claro",
  "Line Level Sync": "Sincronização de Nível de Linha",
  "Line Level": "Nível de Linha",
  "Lyrics (optional)": "Letras (opcional)",
  "Lyrics Sync Editor": "Editor de Sincronização de Letras",
  Manage: "Gerenciar",
  Monthly: "Mensal",
  "Most popular": "Mais populares",
  "No new notifications": "Sem novas notificações",
  "No results": "Sem resultados",
  "No songs in library": "Sem músicas na biblioteca",
  "No songs in queue": "Sem músicas na fila",
  Notifications: "Notificações",
  Off: "Desligado",
  Or: "Ou",
  "Plan canceled, will end in": "Plano cancelado, terminará em",
  "Play word in loop": "Tocar palavra em loop",
  "Preparing Youka": "Preparando Youka",
  "Process 2 karaokes at a time": "Processar 2 karaokês por vez",
  "Process 5 karaokes at a time": "Processar 5 karaokês por vez",
  Queue: "Fila",
  Ready: "Pronto",
  "Remove from queue": "Remover da fila",
  "Resume plan": "Retomar plano",
  "Save and Resync": "Salvar e Resincronizar",
  Save: "Salvar",
  "Saving...": "Salvando...",
  Search: "Buscar",
  "Select plan": "Selecionar plano",
  "Sign In": "Entrar",
  "Sign Out": "Sair",
  "Sign Up": "Registrar",
  "Song Name": "Nome da Música",
  "Start typing to search or paste YouTube URL":
    "Comece a digitar para buscar ou cole a URL do YouTube",
  "Start typing to search": "Comece a digitar para buscar",
  "Subtitle Track": "Faixa de Legenda",
  Subtitles: "Legendas",
  Tempo: "Tempo",
  "Terms and Conditions": "Termos e Condições",
  "This action cannot be undone.": "Esta ação não pode ser desfeita.",
  "Thumbnail URL": "URL da Miniatura",
  "To keep the karaoke fun going, please upgrade":
    "Para manter a diversão do karaokê, faça upgrade",
  "Unlock Premium Features with an Upgrade!":
    "Desbloqueie Recursos Premium com um Upgrade!",
  "Update Payment Method": "Atualizar Método de Pagamento",
  "Upgrade to Pro plan to enable":
    "Faça upgrade para o plano Pro para habilitar",
  Upgrade: "Upgrade",
  Version: "Versão",
  Video: "Vídeo",
  Vocals: "Vocais",
  "Waiting in queue": "Aguardando na fila",
  "Word Level Sync": "Sincronização de Nível de Palavra",
  "Word Level": "Nível de Palavra",
  "You need to accept the EULA to use Youka":
    "Você precisa aceitar o EULA para usar Youka",
  "Your lyrics have been saved successfully. A resync is currently in progress. You can monitor the progress in the notification area. Once the resync is complete, you'll be able to see the changes - just hit 'play'.":
    "Suas letras foram salvas com sucesso. Uma ressincronização está em andamento. Você pode acompanhar o progresso na área de notificações. Uma vez que a ressincronização esteja completa, você poderá ver as mudanças - basta apertar 'tocar'.",
  "Your trial version of Youka has expired":
    "Sua versão de teste do Youka expirou",
  "dialogs.youtube.title":
    "Instale o plugin yt-dlp para pesquisar e reproduzir vídeos online",
  "dialogs.youtube.description":
    "Por favor, leia e aceite os seguintes avisos antes de ativar o plugin.",
  "dialogs.youtube.agree": "Li e entendi os avisos acima",
  "dialogs.youtube.install": "Instalar Plugin",
  "dialogs.youtube.install_success": "Plugin instalado com sucesso",
  "dialogs.youtube.install_success_description":
    "Agora você pode pesquisar e reproduzir vídeos online",
  "dialogs.youtube.install_error": "Falha na instalação do Plugin",
  "alert.youtube.description":
    "O Plugin de Pesquisa e Download de Vídeos Online (yt-dlp) não está pré-instalado. Para instalar, clique no botão 'Instalar'.",
  "alert.youtube.install": "Instalar Plugin",
  "dialogs.settings.enable_youtube": "Ativar Plugin yt-dlp",
  "dialogs.youtube.warnings": [
    {
      title: "Conformidade Legal",
      description:
        "Assegure-se de que o uso deste plugin esteja em total conformidade com todas as leis aplicáveis e os termos de serviço de quaisquer plataformas com as quais interaja, como o YouTube.",
    },
    {
      title: "Direitos Autorais e Licenciamento",
      description:
        "Este plugin pode permitir ações (como baixar conteúdo) que podem infringir as leis de direitos autorais ou violar acordos de licença se não usado corretamente. É crucial respeitar os direitos dos criadores de conteúdo e usar o plugin apenas para fins legalmente permitidos.",
    },
    {
      title: "Sem Endosso",
      description:
        "Habilitar este plugin não implica endosso ou apoio por parte de nossa empresa. O plugin é uma entidade separada e não somos responsáveis por sua operação ou quaisquer consequências de seu uso.",
    },
    {
      title: "Responsabilidade do Usuário",
      description:
        "Você é o único responsável por quaisquer ações que realizar usando este plugin. Isso inclui quaisquer consequências legais que possam surgir devido ao uso indevido ou violação dos termos de serviço.",
    },
    {
      title: "Riscos Potenciais",
      description:
        "Esteja ciente de que o uso indevido do plugin pode levar à suspensão da conta ou ações legais por partes afetadas ou plataformas.",
    },
    {
      title: "Consentimento Informado",
      description:
        "Ao prosseguir para habilitar este plugin, você reconhece que leu e entendeu esses avisos e aceita total responsabilidade pelo uso do plugin.",
    },
  ],
  "model.auto": "Selecionar automaticamente o melhor modelo.",
  "model.audioshake.transcription":
    "O 1º melhor modelo, que envolve transcrever e depois alinhar, oferece resultados superiores, mas é acessível exclusivamente para usuários Pay Per Use e Trial (leva até 10 minutos).",
  "model.audioshake":
    "O segundo melhor modelo, alinha-se com as letras fornecidas, onde imprecisões podem levar a resultados abaixo do ideal (levando até 10 minutos).",
  "model.wav2vec2":
    "O terceiro melhor modelo, alinhado com as letras fornecidas, onde imprecisões podem levar a resultados abaixo do ideal, suporta quase todos os idiomas. (levando até 30 segundos)",
  "model.whisper":
    "O 4º melhor modelo, que envolve transcrever e depois alinhar. A letra de saída pode não ser precisa, embora a sincronização seja aceitável (leva até 2 minutos).",
  "sync.line.instructions": [
    "Clique no botão Play para tocar a música e iniciar o processo de sincronização",
    "Clique no botão Definir início quando ouvir a primeira palavra da linha atual",
    "Clique no botão Definir Fim depois de ouvir a última palavra atual",
    "Continue até terminar de sincronizar todas as linhas",
  ],
  Undo: "Desfazer",
  Redo: "Refazer",
  "Set Start": "Definir Início",
  "Set End": "Definir Fim",
  "dialogs.edit_lyrics.transcription":
    "Ao utilizar o modelo de transcrição, o modelo transcreve a música de forma independente e identifica a letra por conta própria, sem depender de nenhuma letra fornecida. Depois, você tem a opção de ajustar a letra usando a ferramenta de sincronização.",
  "Duet Editor": "Editor de Duetos",
  "Manual Line Sync": "Sincronização Manual de Linha",
  "New Style": "Novo Estilo",
  Style: "Estilo",
  Singer: "Cantor",
  "Style Editor": "Editor de Estilo",
  Word: "Palavra",
  Line: "Linha",
  "Split Line": "Dividir Linha",
  "Upgrade to Enable": "Faça Upgrade para Habilitar",
  upgrade_description:
    "Você tem a opção de ouvir ou baixar as faixas de karaokê já geradas. No entanto, se desejar criar faixas de karaokê adicionais, será necessária uma atualização.",
  "dialogs.global.no_user.title": "Nenhum Plano Ativo",
  "dialogs.global.no_user.description":
    "Por favor, faça upgrade para um plano para continuar.",
  "dialogs.global.no_role.title": "Nenhum Plano Ativo",
  "dialogs.global.no_role.description":
    "Por favor, faça upgrade para um plano para continuar.",
  "dialogs.global.blocked_ip.title": "Seu IP está bloqueado",
  "dialogs.global.blocked_ip.description":
    "Por favor, entre em contato com o suporte.",
  "dialogs.global.rate_limit.title": "Limite de Taxa Excedido",
  "dialogs.global.rate_limit.description":
    "Você pode mudar para um plano Pay Per Use para obter acesso ilimitado.",
  "dialogs.global.disk_full.title": "Armazenamento Cheio",
  "dialogs.global.disk_full.description":
    "Por favor, faça upgrade para um plano para continuar.",
  "dialogs.global.too_big.title":
    "O arquivo de áudio excede o limite de tamanho.",
  "dialogs.global.too_big.description":
    "Observe que o arquivo de áudio não pode exceder a duração máxima de 15 minutos.",
  Help: "Ajuda",
  Original: "Original",
  Sort: "Ordenar",
  "sort.date.asc": "Data de criação (do mais antigo para o mais recente)",
  "sort.date.desc": "Data de criação (do mais recente para o mais antigo)",
  "sort.title.asc": "Título (A a Z)",
  "sort.title.desc": "Título (Z a A)",
  Start: "Início",
  End: "Fim",
  Time: "Tempo",
  "dialogs.trim.title": "Cortar",
  "dialogs.trim.description":
    "Use a borda ajustável na forma de onda para escolher a parte da música que você deseja manter.",
  Related: "Relacionado",
  preserve_vocals: "Preservar Vocais",
  preserve_vocals_description:
    "Ative isto para preservar as vozes, como os vocais de apoio.",
  "Separate Audio": "Separar Áudio",
  "Separate Model": "Modelo de Separação",
  "Add Lyrics": "Adicionar Letras",
  "Background Image or Video": "Imagem ou Vídeo de Fundo",
  Docs: "Documentos",
  Watch: "Assistir",
  Hide: "Esconder",
  "watch.sync.title": "Como consertar a sincronização das letras facilmente?",
  "watch.sync.url": "https://www.youtube.com/watch?v=kEHzfAwQBzo",
  Review: "Revisão",
  "watch.review.title": "Avalie Youka no Trustpilot",
  "Import Subtitles": "Importar Legendas",
  Import: "Importar",
  "How to use": "Como usar",
  Uppercase: "Maiúsculas",
  "Open Dual Screen": "Abrir Dupla Tela",
  "Close Dual Screen": "Fechar Dupla Tela",
  "Import Karaoke File": "Importar Arquivo de Karaokê",
  "dialogs.import_karaoke.title": "Importar Karaoke de Arquivo",
  "dialogs.import_karaoke.description":
    "Importe um vídeo ou arquivo de áudio e um arquivo LRC para criar um karaokê.",
  optional: "opcional",
  "Trial Expired": "Teste Expirado",
  "Subtitles Settings": "Configurações de Subtítulos",
  Milliseconds: "Milissegundos",
  Seconds: "Segundos",
  Text: "Texto",
  Enabled: "Habilitado",
  Duration: "Duração",
  Gap: "Gap",
  Offset: "Offset",
  "Min Duration": "Duração Mínima",
  "Max Duration": "Duração Máxima",
  "Fade In": "Fade In",
  "Fade Out": "Fade Out",
  "plugins.title.title": "Mostrar o Título da Música",
  "plugins.title.description": "Mostrar o título da música no início do vídeo",
  "plugins.gap_text.title": "Texto de Gap Silencioso",
  "plugins.gap_text.description": "Mostrar o texto no gap entre os subtítulos",
  "plugins.gap_progress_bar.title": "Barra de Progresso de Gap Silencioso",
  "plugins.gap_progress_bar.description":
    "Mostrar uma barra de progresso no gap entre os subtítulos",
  "plugins.fade.title": "Efeito Fade",
  "plugins.fade.description":
    "Mostrar o efeito Fade in e Fade out dos subtítulos",
  "plugins.offset.title": "Offset",
  "plugins.offset.description":
    "Mover os subtítulos por uma certa quantidade de segundos",
  "plugins.countdown.title": "Contagem Regressiva",
  "plugins.countdown.description":
    "Mostrar uma contagem regressiva no gap entre os subtítulos",
  Auto: "Automático",
  Subword: "Subpalavra",
  Countdown: "Contagem Regressiva",
  "Restart required": "Reiniciar",
  "Reindex Library": "Reindexar Biblioteca",
  "Create playlist": "Criar Playlist",
  "Are you sure you want to delete?": "Tem certeza que deseja deletar?",
  "Add to playlist": "Adicionar à playlist",
  "New playlist": "Nova playlist",
  "Remove from this playlist": "Remover da esta playlist",
  Songs: "Músicas",
  Playlists: "Playlists",
  Name: "Nome",
  Photo: "Foto",
  "No playlists": "Nenhuma playlist",
  "Welcome to Youka": "Bem-vindo ao Youka",
  "Search songs online": "Buscar músicas online",
  "create.file.title": "Criar Karaoke a partir de um arquivo",
  "create.file.description":
    "Envie seu arquivo MP3, MP4 ou outros formatos para criar instantaneamente um vídeo de karaokê com letras sincronizadas.",
  "create.online.title": "Criar Karaoke a partir de músicas online",
  "create.online.description":
    "Pesquise músicas online ou cole o URL de uma música para criar instantaneamente um vídeo de karaokê com letras sincronizadas.",
  "Change Background": "Alterar Fundo",
  "Duet Line Split": "Dividir Linha de Dueto",
  Both: "Ambos",
  Custom: "Personalizado",
  Edited: "Editado",
  Trimmed: "Cortado",
  Instrumental: "Instrumental",
  "Add Subword": "Adicionar Subpalavra",
  "plugins.max_chars.title": "Máximo de caracteres por linha",
  "plugins.max_chars.description": "Limitar o número de caracteres por linha",
  Limit: "Limite",
  "Background Box": "Caixa de Fundo",
  Height: "Altura",
  Width: "Largura",
  Alpha: "Alfa",
  Color: "Cor",
  Duplicate: "Duplicar",
  "Convert to 16x9": "Converter para 16x9",
  "Resize Video": "Redimensionar Vídeo",
  "Line Alignment": "Alinhamento de Linha",
  "Shadow Color": "Cor de Sombra",
  "Outline Color": "Cor de Contorno",
  "Active Color": "Cor Ativa",
  "Secondary Color": "Cor Secundária",
  "Primary Color": "Cor Primária",
  "Auto Alignment": "Alinhamento Automático",
  "Auto Color": "Cor Automática",
  "Singer 1": "Cantor 1",
  "Singer 2": "Cantor 2",
  "Top Row": "Linha Superior",
  "Bottom Row": "Linha Inferior",
  "Border Style": "Estilo de Bordo",
  "Font Name": "Nome da Fonte",
  "Experimental Subtitles Display": "Mostrar Subtítulos Experimentais",
  Position: "Posição",
  "Timing Indicator": "Indicador de Tempo",
  General: "Geral",
  Styles: "Estilos",
  Thumbnail: "Miniatura",
  "create.url.title": "Criar Karaokê a partir de URL",
  "create.url.description":
    "Criar karaokê a partir de uma URL compatível com yt-dlp",
  "Paste a URL or start typing to search":
    "Cole uma URL ou comece a digitar para buscar",
  Top: "Topo",
  Bottom: "Baixo",
  Center: "Centro",
  "Auto Line Break": "Dividir Linha Automaticamente",
  "Fill Color": "Cor de Preenchimento",
  "Active Line Color": "Cor de Linha Ativa",
  "Waiting Line Color": "Cor de Linha em Espera",
  "Set as Default": "Definir como Padrão",
  Default: "Padrão",
  "Make Default": "Definir como Padrão",
  Image: "Imagem",
  Pause: "Pausar",
  File: "Arquivo",
  "Debug Info": "Informações de Debug",
  "File Type": "Tipo de Arquivo",
  Language: "Idioma",
  "Reset Settings": "Resetar Configurações",
  "Failed to start Youka": "Erro ao iniciar Youka",
  Legacy: "Tradicional",
  Transcription: "Transcrição",
  Alignment: "Alinhamento",
  Imported: "Importado",
  "With Backing Vocals": "Com Vocais de Apoio",
  Stem: "Stem",
  Clear: "Limpar",
  "Open Directory": "Abrir Diretório",
  "Advanced Settings": "Configurações Avançadas",
  "How to Add a Background Black Box to Subtitles":
    "Como adicionar uma caixa preta de fundo às legendas",
  "How to Adjust the Line Length": "Como ajustar o comprimento da linha",
  "How to Cancel Your Subscription": "Como cancelar sua assinatura",
  "How to Center Subtitles": "Como centralizar as legendas",
  "How to Delete a Karaoke": "Como excluir um karaokê",
  "How to Edit the lyrics": "Como editar as letras",
  "How to Fix the Sync": "Como corrigir a sincronização",
  "How to Keep Choirs": "Como manter os coros",
  "How to Keep the Original Singer’s Voice":
    "Como manter a voz original do cantor",
  "How to Set Up a Duet": "Como configurar um dueto",
  "How to Speed Up the Download Process":
    "Como acelerar o processo de download",
  "How to Transfer Your Karaoke Library to a New Computer":
    "Como transferir sua biblioteca de karaokê para um novo computador",
  "How to Trim a Karaoke Video": "Como cortar um vídeo de karaokê",
  FAQ: "FAQ",
  "library.description":
    "Acesse e gerencie todas as faixas de karaokê que você criou. Edite, organize e aperfeiçoe seus projetos.",
  "How to Change the Background Video": "Como alterar o vídeo de fundo",
  "Auto Size": "Tamanho Automático",
  "dialogs.global.no_credits.title": "Nenhum crédito disponível",
  "dialogs.global.no_credits.description":
    "Por favor, recarregue créditos para continuar",
  "Credits are over! Click to buy more":
    "Os créditos acabaram! Clique para comprar mais",
  "How to Add a Line Break": "Como adicionar um salto de linha",
  "dialogs.global.no_user.many_emails_description":
    "O acesso foi bloqueado devido a múltiplos logins usando diferentes endereços de e-mail. Por favor, adquira uma assinatura para continuar.",
  "dialogs.global.no_user.virtual_machine_description":
    "O acesso foi bloqueado porque você está usando uma Máquina Virtual. Para acessar o teste gratuito, instale o Youka em um sistema operacional padrão. Se você tiver uma assinatura, renove-a para recuperar o acesso. Se você não precisar de geração contínua de karaokê, pode optar por um plano de pagamento por uso, garantindo que você só seja cobrado quando criar novos conteúdos de karaokê.",
  "Import Stem": "Importar Stem",
  "Active Outline Color": "Cor de Contorno Ativa",
  "Inactive Outline Color": "Cor de Contorno Inativa",
  "Inactive Line Color": "Cor de Linha Inativa",
  "Active Line": "Linha Ativa",
  "Inactive Line": "Linha Inativa",
  "End Extra": "Extra ao final",
  Expand: "Expandir",
  Collapse: "Contrair",
  "Copy Line": "Copiar linha",
  "Copy Word": "Copiar palavra",
  "Cut Line": "Cortar linha",
  "Cut Word": "Cortar palavra",
  "Delete Line": "Excluir linha",
  "Delete Subword": "Excluir subpalavra",
  "Delete Word": "Excluir palavra",
  "Add Line": "Adicionar linha",
  "Add Word": "Adicionar palavra",
  // "Add Subword": "Adicionar subpalavra",
  "Paste Line": "Colar linha",
  "Paste Word": "Colar palavra",
  "Paste Subword": "Colar subpalavra",
  "Play Line": "Reproduzir linha",
  "Play Word": "Reproduzir palavra",
  "Select Line": "Selecionar linha",
  "Manual Sync": "Sincronização manual",
  "Trim Start": "Cortar início",
  "Trim End": "Cortar fim",
  "Creating will use 1 credit": "Criar usará 1 crédito",
  All: "Todos",
  "Number of Singers": "Número de cantores",
  "Style Mapping": "Mapeamento de Estilo",
  "Associate subtitle styles with singers":
    "Associar estilos de legendas aos cantores",
  "Upper first line": "Primeira linha superior",
  "Upper second line": "Segunda linha superior",
  "Lower first line": "Primeira linha inferior",
  "Lower second line": "Segunda linha inferior",
  Lock: "Bloquear",
  "2 Lines": "2 linhas",
  "4 Lines": "4 linhas",
  Static: "Estático",
  Dynamic: "Dinâmico",
  "Subtitles Type": "Tipo de legendas",
  "Danger Zone": "Zona Perigosa",
  Copy: "Copiar",
  Copied: "Copiado",
  "Copy Settings": "Copiar Configurações",
  "cta.social.title": "Ganhe 50 créditos GRÁTIS!",
  "cta.social.description":
    "Compartilhe uma postagem sobre o Youka nas redes sociais, marque-nos e ganhe 50 créditos grátis por plataforma!",
  "cta.social.description.2":
    "Clique para visitar a página do Facebook do Youka, dê um like, compartilhe uma postagem e envie seu e-mail no chat para receber 50 créditos grátis!",
  "Merge Line": "Unir linha",
  Player: "Reprodutor",
  "Key Step": "Etapa de tom",
  "Tempo Step": "Etapa de tempo",
  "Shift Line Forward": "Deslocar linha para frente",
  "Shift Line Backward": "Deslocar linha para trás",
  "create.description":
    "Crie karaokê a partir de arquivos de áudio ou vídeo (MP3, MP4 e mais), ou cole um URL para gerar instantaneamente um vídeo de karaokê com letras sincronizadas.",
  "No file chosen": "Nenhum arquivo escolhido",
  "Choose File": "Escolher arquivo",
  "Watch Quick Start Video": "Assistir vídeo de início rápido",
  "Export Settings": "Exportar configurações",
  "Import Settings": "Importar configurações",
  "Video Guides": "Guides de vídeo",
  "Quick Start Guide": "Guia de início rápido",
  "Lyrics Sync Guide": "Guia de sincronização de letras",
  Resolution: "Resolução",
  "Subtitles Preset": "Predefinição de legendas",
  Preset: "Predefinição",
  Done: "Concluído",
  "New Style Mapping": "Novo mapeamento de estilo",
  Horizontal: "Horizontal",
  Vertical: "Vertical",
  Square: "Quadrado",
  New: "Novo",
  "New Subtitles Preset": "Nova predefinição de legendas",
  "Change Aspect Ratio": "Alterar proporção da tela",
  "copyright.title.a": "Eu aceito a",
  "copyright.title.b": "Confirmação de Uso da Música",
  "copyright.description":
    "Ao marcar esta caixa, você confirma que (A) possui todos os direitos sobre a música incluída neste vídeo; ou (B) a música está em domínio público; ou (C) você tem permissão de todos os detentores de direitos necessários para usar a música na plataforma Youka.",
  "Add Intro Video": "Adicionar vídeo de introdução",
  "dialogs.intro.description":
    "Adicione um vídeo personalizado ao início do karaokê",
  Transition: "Transição",
  Fade: "Desvanecer",
  "Circle Open": "Abrir círculo",
  "Circle Close": "Fechar círculo",
  "Diagonal Open": "Abrir diagonal",
  "Diagonal Close": "Fechar diagonal",
  "Smooth Left": "Suave para a esquerda",
  "Smooth Right": "Suave para a direita",
  Squares: "Quadrados",
  Dissolve: "Dissolver",
  Type: "Tipo",
  "Song Title": "Título da música",
  Artists: "Cantores",
  Artist: "Cantor",
  "Parse Titles": "Analisar títulos",
  "sort.artist.asc": "Cantor (A a Z)",
  "sort.artist.desc": "Cantor (Z a A)",
  "Title Style": "Estilo de título",
  "Artist Style": "Estilo de cantor",
  "Analyse Library": "Analisar biblioteca",
  "No Filter": "Sem filtro",
  "credits.message_one": "Este usará {{count}} crédito",
  "credits.message_other": "Este usará {{count}} créditos",
  "credits.badge_one": "{{count}} crédito",
  "credits.badge_other": "{{count}} créditos",
  "Provide song lyrics to save credits":
    "Forneça letras de canções para economizar créditos",
  "Upload to Cloud Library": "Carregar para a biblioteca em nuvem",
  "Cloud Library": "Biblioteca em nuvem",
  "Open Cloud Library": "Abrir biblioteca em nuvem",
};
